<table mat-table [dataSource]="links" class="linksTable">
  <ng-container matColumnDef="link">
    <th mat-header-cell *matHeaderCellDef>Ссылка</th>
    <td mat-cell *matCellDef="let link" class="linkDescription">{{ link.link }}</td>
  </ng-container>
  <ng-container matColumnDef="menu">
    <th mat-header-cell *matHeaderCellDef>
      <button mat-icon-button (click)="addLink()">
        <mat-icon>add</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let link">
      <button mat-icon-button color="warn" (click)="removeLink(link)">
        <mat-icon>remove</mat-icon>
      </button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
</table>
